import { fromJS } from 'immutable';
export var SET_INTERFACE_SORT = 'service/SET_INTERFACE_SORT';
export var SET_INTERFACE_DATA = 'service/SET_INTERFACE_DATA';
export var SET_DATA_HANDLE_SORT = 'service/SET_DATA_HANDLE_SORT';
export var SET_DATA_HANDLE_DATA = 'service/SET_DATA_HANDLE_DATA';
export var SET_DATA_PROVIDE_DATA = 'service/SET_DATA_PROVIDE_DATA';
export var SET_DIALOG_INFO = 'service/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'service/CLEAR_DIALOG_INFO';
export var SET_SERVICE_LIST = 'service/SET_SERVICE_LIST';
export var RESET = 'service/RESET';
export var setInterfaceSort = function setInterfaceSort(sort) {
  return {
    type: SET_INTERFACE_SORT,
    sort: sort
  };
};
export var setInterfaceData = function setInterfaceData(data) {
  return {
    type: SET_INTERFACE_DATA,
    data: data
  };
};
export var setDataHandleSort = function setDataHandleSort(sort) {
  return {
    type: SET_DATA_HANDLE_SORT,
    sort: sort
  };
};
export var setDataHandleData = function setDataHandleData(data) {
  return {
    type: SET_DATA_HANDLE_DATA,
    data: data
  };
};
export var setDataProvideData = function setDataProvideData(data) {
  return {
    type: SET_DATA_PROVIDE_DATA,
    data: data
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo(data) {
  return {
    type: CLEAR_DIALOG_INFO,
    data: data
  };
};
export var setServiceList = function setServiceList(data) {
  return {
    type: SET_SERVICE_LIST,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initDialogInfo = {
  // mode: edit
  mode: '',
  data: {}
};
var initialState = fromJS({
  interfaceData: [],
  dataHandleData: [],
  dataProvideData: [],
  // table sort
  interfaceSort: {
    field: 'name',
    desc: false
  },
  dataHandleSort: {
    field: 'target',
    desc: false
  },
  serviceList: [],
  dialogInfo: initDialogInfo
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_INTERFACE_SORT:
      return state.set('interfaceSort', fromJS(action.sort));

    case SET_INTERFACE_DATA:
      return state.set('interfaceData', fromJS(action.data));

    case SET_DATA_HANDLE_SORT:
      return state.set('dataHandleSort', fromJS(action.sort));

    case SET_DATA_HANDLE_DATA:
      return state.set('dataHandleData', fromJS(action.data));

    case SET_DATA_PROVIDE_DATA:
      return state.set('dataProvideData', fromJS(action.data));

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(action.data));

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(initDialogInfo));

    case SET_SERVICE_LIST:
      return state.set('serviceList', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}